export default {
    title: "Lista de planos",
    add_plan_button: "Adicionar plano",
    edit_button: "Editar",
    form: {
        name: "Nome do plano",
        description: "Descrição",
        billing_type: "Tipo de mensalidade",
        prepaid: "Pré-pago",
        postpaid: "Pós-pago",
        base_value: "Valor base",
        incentivized_revenue_share: "% Do faturamento incentivado",
        retention_revenue_share: "% Do faturamento de retenção",
        pricetable_clients: "Tabela de preço de clientes",
        pricetable_credits: "Tabela de preço de créditos",
        pricetable_extra_credits: "Tabela de preço créditos extras",
        included_integrations: "Integrações incluídas",
        price_per_integration: "Preço por integração extra",
        included_branches: "Filiais incluídas",
        price_per_branch: "Preço por filial",
        included_users: "Usuários incluídos",
        price_per_user: "Preço por usuário",
        included_users_per_branch: "Usuários incluídos por filial",
        currency: "Moeda",
        currency_brl: "BRL — Real Brasileiro",
        currency_usd: "USD — Dólar Americano",
        one_invoice_per_branch_plus_base: "Gerar uma fatura por filial + fatura base da matriz",
        one_invoice_per_branch_plus_base_help: "Se ativado, cada filial receberá uma fatura com seu consumo de créditos e a matriz receberá a fatura com custos fixos e taxas.",
        main_branch: "Filial Matriz",
        select_main_branch: "Selecione a filial matriz...",
        main_branch_help: "A filial selecionada como Matriz concentrará a cobrança da taxa base e dos custos fixos.",
        select_main_branch_warning: "Selecione a Filial Matriz para o modelo de faturamento por filial.",
        readjustment: {
            title: "Reajuste",
            percentage: "Percentual de reajuste (%)",
            placeholder: "Digite o percentual de reajuste",
            apply: "% Aplicar",
            help: "Aplica o percentual sobre o preço base, contatos e créditos.",
            success: "Reajuste aplicado! Todos os valores foram reajustados em {percentage}%.",
        },
        change_reason: {
            label: "Motivo da alteração",
            placeholder: "Ex: Upgrade por crescimento de usuários",
            required_alert: "Atenção: Como houve alterações, o preenchimento do motivo é obrigatório.",
            required_validation: "Informe o motivo da alteração antes de salvar.",
        },
        no_changes_detected: "Nenhuma alteração detectada.",
        discount_table: {
            title: "Descontos",
            add_button: "+ Incluir desconto",
            discount_index: "Desconto {0}",
            value: "Valor do desconto",
            start_date: "Início da vigência",
            end_date: "Desconto válido até",
            description: "Descrição",
            description_placeholder: "Descreva o motivo ou detalhes do desconto...",
        },
        save: "Salvar",
        success_message: "Configurações atualizadas",
        price_table: {
            interval: "Intervalo",
            unit_value: "Valor unitário",
            add_button: "Adicionar",
        },
    },
};
